import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "../DealsAndOffers/dealsAndOffers.css";
import ListExperienceCenter from "./listExperienceCenter";
import ListExperienceCenterForm from "./listUserRequest";
import "./headerExperienceCenter.css";
import { Skeleton } from "antd";

const STORAGE_KEY = "experience_center_header_tab";

const HeaderExperienceCenter = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "experience_center_list"
  );
  const [loading, setLoading] = useState(false);


  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;

    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className={`bg-white border-10 padding-10 shadow-box ${loading ? "disabled-tabs" : ""}`}
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", marginBottom: "20px" }}>
          <div className="hover_panel">
            <h4
              className={selectedTable === "experience_center_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("experience_center_list")}
            >
              Experience Center
            </h4>

            <h4
              className={selectedTable === "experience_center_user_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("experience_center_user_list")}
            >
              User List
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div className={`fade-wrapper ${loading ? "hide" : ""}`}>
          <div style={{ display: selectedTable === "experience_center_list" ? "block" : "none" }}>
            <ListExperienceCenter />
          </div>

          <div style={{ display: selectedTable === "experience_center_user_list" ? "block" : "none" }}>
            <ListExperienceCenterForm />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default HeaderExperienceCenter;
